import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import StatusPage from '../components/StatusPage';

export default function Verified() {
  const search = useLocation().search;
  const [status,setStatus] = useState('Checking your confirmation…');
  useEffect(() => {
    const params = new URLSearchParams(search), id = params.get('id'), mvp = params.get('mvp') || 've';
    if (!id) { setStatus('Open the complete confirmation link from your email.'); return; }
    let stopped = false;
    const controller = new AbortController();
    fetch('/api/verifyUser', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id,mvp}), signal:controller.signal })
      .then(response => { if (!response.ok) throw new Error('unavailable'); return response.json(); })
      .then(data => { if (stopped) return; if (data.success === true || data.success === 'true') { window.location.href = 'https://first1000.substack.com/archive/'; } else setStatus('This confirmation didn’t complete. Please try the link in your email again.'); })
      .catch(() => { if (!stopped) setStatus('We couldn’t complete confirmation. Please try the link in your email again.'); });
    return () => { stopped = true; controller.abort(); };
  }, [search]);
  return <StatusPage title="One moment." message={status}/>;
}
